module.exports = __webpack_public_path__ + "static/img/2.be20dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/weierli/2.png
// module id = k4YG
// module chunks = 19